import { paymentAPI } from './api';

// Razorpay payment processing utility
export const processRazorpayPayment = async (bookingId, bookingData) => {
  try {
    // Debug logging
    console.log('=== RAZORPAY PAYMENT DEBUG ===');
    console.log('Booking ID received:', bookingId);
    console.log('Booking ID type:', typeof bookingId);
    console.log('Booking data:', bookingData);
    
    // Step 1: Create Razorpay order
    const orderResponse = await paymentAPI.createOrder({ bookingId });
    
    if (!orderResponse.success) {
      throw new Error(orderResponse.message || 'Failed to create payment order');
    }

    const { orderId, keyId, amount, bookingDetails } = orderResponse;

    // Step 2: Initialize Razorpay checkout
    const options = {
      key: keyId, // Test key from backend
      amount: amount, // Amount in paise
      currency: 'INR',
      name: 'Sahayak',
      description: `Payment for ${bookingDetails?.service || 'service'} service`,
      order_id: orderId,
      image: '/logo192.png', // Your logo
      method: {
        upi: true,
        card: true,
        netbanking: true,
        wallet: true,
        emi: false,
        paylater: false
      },
      config: {
        display: {
          blocks: {
            utib: { //AXIS Bank
              name: 'Pay using Axis Bank',
              instruments: [
                {
                  method: 'card'
                },
                {
                  method: 'netbanking'
                },
              ],
            },
            other: {
              name: 'Other Payment Methods',
              instruments: [
                {
                  method: 'card',
                },
                {
                  method: 'netbanking',
                },
                {
                  method: 'upi'
                },
                {
                  method: 'wallet'
                }
              ],
            },
          },
          hide: [
            {
              method: 'emi'
            }
          ], 
          sequence: ['block.utib', 'block.other'],
          preferences: {
            show_default_blocks: true,
          },
        },
      },
      handler: async function (response) {
        try {
          // Step 3: Verify payment on backend
          const verifyResponse = await paymentAPI.verifyPayment({
            bookingId: bookingId,
            razorpayPaymentId: response.razorpay_payment_id,
            razorpayOrderId: response.razorpay_order_id,
            razorpaySignature: response.razorpay_signature
          });

          if (verifyResponse.success) {
            // Payment successful
            return {
              success: true,
              paymentId: response.razorpay_payment_id,
              message: 'Payment completed successfully!'
            };
          } else {
            throw new Error(verifyResponse.message || 'Payment verification failed');
          }
        } catch (error) {
          console.error('Payment verification error:', error);
          throw new Error('Payment verification failed');
        }
      },
      prefill: {
        name: bookingData.customerName || '',
        email: bookingData.customerEmail || '',
        contact: bookingData.customerPhone || ''
      },
      notes: {
        booking_id: bookingId,
        service_type: bookingDetails?.service || 'general'
      },
      theme: {
        color: '#4F46E5' // Sahayak brand color
      },
      modal: {
        ondismiss: function() {
          console.log('Payment cancelled by user');
        }
      }
    };

    // Step 4: Open Razorpay checkout
    return new Promise((resolve, reject) => {
      const rzp = new window.Razorpay({
        ...options,
        handler: async function (response) {
          try {
            const verifyResponse = await paymentAPI.verifyPayment({
              bookingId: bookingId,
              razorpayPaymentId: response.razorpay_payment_id,
              razorpayOrderId: response.razorpay_order_id,
              razorpaySignature: response.razorpay_signature
            });

            if (verifyResponse.success) {
              resolve({
                success: true,
                paymentId: response.razorpay_payment_id,
                message: 'Payment completed successfully!'
              });
            } else {
              reject(new Error(verifyResponse.message || 'Payment verification failed'));
            }
          } catch (error) {
            console.error('Payment verification error:', error);
            reject(new Error('Payment verification failed'));
          }
        }
      });

      rzp.on('payment.failed', function (response) {
        console.error('Payment failed:', response.error);
        reject(new Error(response.error.description || 'Payment failed'));
      });

      rzp.open();
    });

  } catch (error) {
    console.error('Razorpay payment error:', error);
    throw new Error(error.message || 'Payment processing failed');
  }
};

// Test payment function for development
export const testRazorpayIntegration = () => {
  if (typeof window.Razorpay === 'undefined') {
    console.error('Razorpay script not loaded');
    return false;
  }
  
  console.log('Razorpay integration ready for testing');
  return true;
}; 